module.exports = __webpack_public_path__ + "img/loader-white.86efc25e.svg";